import React, { useState, useEffect } from 'react';
import Tooltip from '../Helpers/Tooltip';

function StatsContainer({ selectedData }) {
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [tooltipContent, setTooltipContent] = useState('');
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const handleClickOutside = () => {
            setTooltipVisible(false);
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    if (!selectedData) {
        return null;
    }

    const invulnerableSave = selectedData['INVULNERABLE SAVE'];
    const fnpSave = selectedData['FEEL NO PAIN'];
    let sv = `${selectedData.SV}`;
    const invulnerableSaveDescription = selectedData['INVULNERABLE SAVE DESCRIPTION'];

    if (invulnerableSave)
        sv += ` / ${invulnerableSave}++`;
    
    if (fnpSave)
        sv += ` / ${fnpSave}+++`;

    const handleTooltip = (event, content) => {
        event.stopPropagation();
        const rect = event.target.getBoundingClientRect();
        const scrollLeft = document.documentElement.scrollLeft;
        const scrollTop = document.documentElement.scrollTop;
        setTooltipContent(content);
        setTooltipPosition({ x: rect.left + scrollLeft, y: rect.top + scrollTop });
        setTooltipVisible(true);
    };

    return (
        <div className="mt-2">
            <table className="w-full border-collapse border border-slate-200 text-center">
                <tbody>
                <tr>
                    <th className="px-2 py-1 border border-slate-300 bg-slate-200">M</th>
                    <th className="px-2 py-1 border border-slate-300 bg-slate-200">T</th>
                    <th className="px-2 py-1 border border-slate-300 bg-slate-200">SV</th>
                    <th className="px-2 py-1 border border-slate-300 bg-slate-200">W</th>
                    <th className="px-2 py-1 border border-slate-300 bg-slate-200">LD</th>
                    <th className="px-2 py-1 border border-slate-300 bg-slate-200">OC</th>
                </tr>
                <tr>
                    <td className="px-2 py-1 border border-slate-200">{selectedData.M}</td>
                    <td className="px-2 py-1 border border-slate-200">{selectedData.T}</td>
                    <td className="px-2 py-1 border border-slate-200">
                        {sv}
                        {invulnerableSaveDescription && (
                            <button
                                type="button"
                                className="underline underline-offset-2 decoration-slate-400 font-medium text-xs uppercase tracking-wide"
                                onClick={(event) => handleTooltip(event, invulnerableSaveDescription)}
                            >
                                *
                            </button>
                        )}
                    </td>
                    <td className="px-2 py-1 border border-slate-200">{selectedData.W}</td>
                    <td className="px-2 py-1 border border-slate-200">{selectedData.LD}</td>
                    <td className="px-2 py-1 border border-slate-200">{selectedData.OC}</td>
                </tr>
                </tbody>
            </table>
            <Tooltip
                visible={tooltipVisible}
                content={tooltipContent}
                position={tooltipPosition}
                onClick={() => setTooltipVisible(false)}
            />
        </div>
    );
}

export default StatsContainer;